import { render } from "./FarmerDash.vue?vue&type=template&id=4411e706"
import script from "./FarmerDash.vue?vue&type=script&lang=js"
export * from "./FarmerDash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__